import React, { Component } from "react";
import { translate } from "react-i18next";

// Slide Show
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../assets/scss/slider_modify.css";

//Google analytics
import { gaEvent } from "../../ga/analytics";
import {
	CATEGORY_HOMEPAGE,
	ACTION_MONEYTABLE_PRODUCT,
	ACTION_HRTABLE_PRODUCT,
	ACTION_REVIEW_VIDEO,
	CATEGORY_MONEYTABLE,
	ACTION_HOMEPAGE,
	CATEGORY_HRTABLE,
	ACTION_LEARN_MORE,
} from "../../ga/constant";

import { HeroDiv } from "../style/hero";

class Hero extends Component {
	sendToGa = (type, label) => {
		if (type === "MoneyTable Product") {
			gaEvent(CATEGORY_HOMEPAGE, ACTION_MONEYTABLE_PRODUCT);
			gaEvent(CATEGORY_MONEYTABLE, ACTION_HOMEPAGE);
		}

		if (type === "HRTable Product") {
			gaEvent(CATEGORY_HOMEPAGE, ACTION_HRTABLE_PRODUCT);
			gaEvent(CATEGORY_HRTABLE, ACTION_HOMEPAGE);
		}

		if (type === "Review Video") {
			gaEvent(CATEGORY_HOMEPAGE, ACTION_REVIEW_VIDEO);
		}

		if (type === "Learn More") {
			gaEvent(CATEGORY_HOMEPAGE, ACTION_LEARN_MORE, "Go to HR Table Product");
		}
	};

	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
		};
		this.openModal = this.openModal.bind(this);
	}
	openModal() {
		this.setState({ isOpen: true });
	}
	render() {
		const { t } = this.props;
		const url_lang = this.props.i18n.language === "en" ? "/en" : "";

		return (
			<div className="hero">
				<HeroDiv>
					<div className="homepage-hero--container">
						<h1 className="homepage-hero--title__1">
							{" "}
							{t("homepage_hero_title1")}
						</h1>
						<h2 className="homepage-hero--title__2">
							{" "}
							{t("homepage_hero_title2")}
						</h2>
						<p className="homepage-hero--title__3">
							{" "}
							{t("homepage_hero_title3")}
						</p>
					</div>
					<div className="go-daycash-btn homepage-hero--container__btn">
						<a
							style={{ width: 220 }}
							className="go-daycash-btn--link"
							href={`${url_lang}/contact`}
						>
							{this.props.t("gotoknow_dc")}
							<span className="glyphicon glyphicon-arrow-right"></span>
						</a>
					</div>
				</HeroDiv>
				{/* end bg */}
			</div>
		);
	}
}

export default translate("translations")(Hero);



// WEBPACK FOOTER //
// ./src/components/home/hero.jsx